import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";
import { CircularChartCard, LoadingIndicator } from "../../components/v2/cards";

const RewardsTopCards = ({
  usageChartData,
  formatCompactNumber,
  formatUsageLegendValue,
  statsLoading,
  averageUsageRate,
  averageUsageDelta,
}) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="rewards-list__top-cards">
      <div className="rewards-list__stat-card">
        <CircularChartCard
          title={translate("v2_rewards_top_obtention", lang)}
          subtitle={translate("v2_rewards_top_obtention_sub", lang)}
          data={usageChartData}
          colors={["#6C8EBF", "#1F3451"]}
          startRotation={-90}
          drawOrder="reverse"
          legendOrder="reverse"
          legendPosition="right"
          formatValue={formatCompactNumber}
          formatLegendValue={formatUsageLegendValue}
          showLegendPercentage={false}
          loading={statsLoading}
          className="rewards-list__usage-card"
        />
      </div>

      <div className="rewards-list__stat-card rewards-list__avg-card">
        <div className="rewards-list__card-header">
          <h3 className="rewards-list__card-title">{translate("v2_rewards_top_avg_claim", lang)}</h3>
          <p className="rewards-list__card-subtitle">{translate("v2_rewards_top_avg_claim_sub", lang)}</p>
        </div>
        <div className="rewards-list__avg-card-body">
          {statsLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              <div className="rewards-list__avg-value">{averageUsageRate}%</div>
              <div className="rewards-list__avg-subline">
                <span
                  className={`rewards-list__avg-badge ${averageUsageDelta < 0 ? "rewards-list__avg-badge--down" : ""}`}
                >
                  {averageUsageDelta > 0 ? `+${averageUsageDelta}%` : `${averageUsageDelta}%`}
                </span>
                <span>{translate("v2_vs_last_month", lang)}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsTopCards;
